"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.childRelationshipList = void 0;
exports.childRelationshipList = [
    {
        label: "Son",
        value: "1",
    },
    {
        label: "Daughter",
        value: "2",
    },
    {
        label: "Step-daughter",
        value: "3",
    },
    {
        label: "Step-son",
        value: "4",
    },
    {
        label: "Adopted daughter",
        value: "5",
    },
    {
        label: "Adopted son",
        value: "6",
    },
];
